import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-18">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 mb-12">
            <div className="flex-shrink-0">
              <Link to="/" className="inline-flex items-center gap-2 mb-3 whitespace-nowrap">
                <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-white text-lg"></i>
                </span>
                <span className="text-xl font-bold font-heading">51黑料</span>
              </Link>
              <p className="text-foreground-300 text-sm max-w-xs leading-relaxed">
                51黑料吃瓜网——汇聚全网最新最热的娱乐爆料内容，7×24小时不打烊。每日黑料大赛，全网独家猛料，实时追踪网红明星最新爆点。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 flex-1">
              <div>
                <h4 className="text-sm font-semibold text-white mb-3 whitespace-nowrap">热门分类</h4>
                <div className="flex flex-col gap-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="text-foreground-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-white mb-3 whitespace-nowrap">快捷入口</h4>
                <div className="flex flex-col gap-2">
                  <Link to="/" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">首页</Link>
                  <Link to="/category/mingxing-bagua" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">每日黑料大赛</Link>
                  <Link to="/category/wanghong-baoliao" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">吃瓜视频</Link>
                  <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">关于我们</Link>
                  <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">联系我们</Link>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-white mb-3 whitespace-nowrap">热门标签</h4>
                <div className="flex flex-col gap-2">
                  <span className="text-foreground-300 text-sm whitespace-nowrap">顶流塌房</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">直播翻车</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">选秀内幕</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">片酬曝光</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">抄袭争议</span>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-white mb-3 whitespace-nowrap">法律声明</h4>
                <div className="flex flex-col gap-2">
                  <span className="text-foreground-300 text-sm whitespace-nowrap">隐私政策</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">用户协议</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">版权声明</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">投诉指引</span>
                  <span className="text-foreground-300 text-sm whitespace-nowrap">免责声明</span>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-white mb-3 whitespace-nowrap">关注我们</h4>
                <div className="flex gap-3">
                  <a href="#" rel="nofollow" className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors" aria-label="微博">
                    <i className="ri-weibo-line text-sm"></i>
                  </a>
                  <a href="#" rel="nofollow" className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors" aria-label="微信">
                    <i className="ri-wechat-line text-sm"></i>
                  </a>
                  <a href="#" rel="nofollow" className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors" aria-label="抖音">
                    <i className="ri-tiktok-line text-sm"></i>
                  </a>
                  <a href="#" rel="nofollow" className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors" aria-label="B站">
                    <i className="ri-bilibili-line text-sm"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-xs text-foreground-400">
              <span>&copy; {new Date().getFullYear()} 51黑料</span>
              <span className="hidden sm:inline">·</span>
              <span>All rights reserved.</span>
            </div>
            <div className="flex gap-4 text-xs text-foreground-400">
              <a href="#" rel="nofollow" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" rel="nofollow" className="hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" rel="nofollow" className="hover:text-primary-400 transition-colors whitespace-nowrap">投诉指引</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}